<template>
    <div class="money-with-indicator">
        <div class="row">
            <div class="col-md-12">
                <label v-text="lblAmount"/>
                <vue-numeric 
                    currency="$" 
                    v-bind:precision="2" 
                    decimal-separator = "." 
                    thousand-separator = " " 
                    v-model="model" 
                    class="form-control"
                    v-bind:max="maxValue"
                    @blur="blur"
                />
            </div>
            <div class="col-md-12" style="font-weight: bolder" v-show="!hideCredit">
                <label v-text="lblNoCredit" :class="classLblNoCredit"/>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .money-with-indicator {
        .limit-reached {
            color: #ff5855;
        }
    }
</style>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
    name: "MoneyWithIndicator",
    props: {
        value: {
            type: Number,
            default: 0,
            description: "Importe"
        },
        lblAmount: {
            type: String,
            default: "Importe",
            description: "Label de Importe"
        },
        maxValue: {
            type: Number,
            default: 9999999,
            description: "Valor Máximo"
        }
    },
    data() {
        return {     
            moneyAvailable: 0,
            moneyAvailableFormatted: "$ 0",
            classLblNoCredit: "",
            hideCredit: true,
            transferReferencesList: []
        };
    },
    computed: {
        model: {
            get() {
                if(this.value == 0)
                    this.validateCredit(this.value);

                return this.value;
            },
            set(value) {
                this.validateCredit(value);
            }
        },
        lblNoCredit() {
            return "De " + this.moneyAvailableFormatted + " disponible";
        }
    },
    methods: {
        GetCredit(context) {
            axiosHelpers.axiosGet("Account/GetCredit", {SearchReferences: true}, context, function(data) {
                context.moneyAvailable = data.ResponseVM.Credit;
                context.moneyAvailableFormatted = data.ResponseVM.FormattedCredit;
                context.hideCredit = data.ResponseVM.HideCredit;

                context.transferReferencesList = data.ResponseVM.TransferReferencesList;
                // Emitir el evento con el arreglo cuando el componente esté montado
                context.$emit('data-loaded', context.transferReferencesList);
            });
        },
        validateCredit(value) {
            var validatedOK = true;

            if(!this.hideCredit && (value > this.moneyAvailable)) {
                this.classLblNoCredit = "limit-reached";
                validatedOK = false;
            } else {
                this.classLblNoCredit = "";
            }

            this.$emit("validatedOK", validatedOK);
            this.$emit("input", value);
        },
        blur() {
            this.$emit("blur");
        }
    },
    beforeMount() {
        this.GetCredit(this);
    }
}
</script>